import moment from "moment";
import JoditEditor from "jodit-react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import {
  setMethodologyLingoEN,
  setMethodologyLingoES,
  setMethodologyLingoFR,
  setMethodologyLingoPT,
  setMethodologyLingoENInterview,
  setMethodologyLingoESInterview,
  setMethodologyLingoPTInterview,
  setMethodologyLingoFRInterview,
} from "../../../../store/slices/content.slice";
import { postMethodologyLingo, putMethodologyLingo } from "../../../../store/middleware";

const config = {
  readonly: false,
  height: 600,
  enableDragAndDropFileToEditor: true,
  uploader: { insertImageAsBase64URI: true },
};

const ACTION_BY_TYPE = {
  EN: setMethodologyLingoEN,
  ES: setMethodologyLingoES,
  PT: setMethodologyLingoPT,
  FR: setMethodologyLingoFR,
  "INTERVIEW - EN": setMethodologyLingoENInterview,
  "INTERVIEW - ES": setMethodologyLingoESInterview,
  "INTERVIEW - PT": setMethodologyLingoPTInterview,
  "INTERVIEW - FR": setMethodologyLingoFRInterview,
};

const LANGUAGE_TRANSLATE_BY_TYPE = {
  EN: "EN - EN",
  ES: "EN - ES",
  PT: "EN - PT",
  FR: "EN - FR",
  "INTERVIEW - EN": "INTERVIEW - EN",
  "INTERVIEW - ES": "INTERVIEW - ES",
  "INTERVIEW - PT": "INTERVIEW - PT",
  "INTERVIEW - FR": "INTERVIEW - FR",
};

const MethodologyLingoforme = ({ setOpenModalConfimSend }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const {
    methodologyLingoEN,
    methodologyLingoES,
    methodologyLingoPT,
    methodologyLingoFR,
    methodologyLingoENInterview,
    methodologyLingoESInterview,
    methodologyLingoPTInterview,
    methodologyLingoFRInterview,
  } = useSelector((state) => state.contentReducer);

  const editors = [
    { type: "EN", title: t("BTN_ENGLISH"), data: methodologyLingoEN },
    { type: "ES", title: t("BTN_SPANISH"), data: methodologyLingoES },
    { type: "PT", title: t("BTN_PORTUGUESE"), data: methodologyLingoPT },
    { type: "FR", title: t("FRENCH"), data: methodologyLingoFR },
    { type: "INTERVIEW - EN", title: `${t("INTERVIEW")}  ${t("BTN_ENGLISH")}`, data: methodologyLingoENInterview },
    { type: "INTERVIEW - ES", title: `${t("INTERVIEW")}  ${t("BTN_SPANISH")}`, data: methodologyLingoESInterview },
    { type: "INTERVIEW - PT", title: `${t("INTERVIEW")}  ${t("BTN_PORTUGUESE")}`, data: methodologyLingoPTInterview },
    { type: "INTERVIEW - FR", title: `${t("INTERVIEW")}  ${t("FRENCH")}`, data: methodologyLingoFRInterview },
  ];

  const handleUpdate = (event, type, id) => {
    try {
      const action = ACTION_BY_TYPE[type];
      if (action) dispatch(action({ id, content: event }));
    } catch (e) {
      console.log(e);
    }
  };

  const handleAddLingoForMe = () => {
    try {
      editors.forEach(({ type, data }) => {
        const body = {
          content: data?.content ?? "",
          textType: "METHODOLOGYLINGOFORME",
          date: moment().format("YYYY-MM-DD"),
          languageTranslate: LANGUAGE_TRANSLATE_BY_TYPE[type],
        };

        if (data?.id) {
          dispatch(putMethodologyLingo({ ...body, id: data.id }));
        } else {
          dispatch(postMethodologyLingo(body));
        }
      });
    } catch (e) {
      console.log(e);
    }
    setTimeout(() => {
      setOpenModalConfimSend(true);
    }, 3000);
  };

  return (
    <div style={{ width: "100%", marginBottom: 50 }}>
      <div className="divButtonLingoforme">
        <button onClick={handleAddLingoForMe} className="addContent">
          {t("BTN_ADD")}
        </button>
      </div>

      {editors.map(({ type, title, data }, index) => (
        <div key={type}>
          <h1 className={`titleEditor${index > 0 ? " mt-20" : ""}`}>{title}</h1>
          <JoditEditor
            config={config}
            onChange={() => {}}
            className="joditEditor"
            value={data?.content || ""}
            onBlur={(e) => handleUpdate(e, type, data?.id)}
          />
        </div>
      ))}
    </div>
  );
};

export default MethodologyLingoforme;
